module.exports = __webpack_public_path__ + "media/images/play-51ad34499adcf69e405fc6bfbcbe484d.png";